export default function AdverView() {
  return (
    <div className="min-h-screen bg-bg-light p-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-text-black">광고 정보</h1>
          <p className="text-gray-500 mt-1">현재 진행 중인 광고를 확인하세요</p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-center py-12 text-gray-500">
            <i className="fas fa-ad text-6xl mb-4 text-gray-300"></i>
            <p className="text-lg mb-2">광고 정보가 없습니다</p>
            <p className="text-sm">백엔드 연동 후 광고 데이터가 표시됩니다</p>
          </div>
        </div>
      </div>
    </div>
  );
}
